import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'

const BASE_PATH = '/lottustech/remessaspagamentos'
const crud = build(validate, BASE_PATH)
const prefix = 'crudConsultaRemessaPagamento'

const actions = new Action(prefix, crud)
const newTypes = {
  SET_BOOLEAN_FILTER: `${prefix}setBooleanFilter`,
  UNMOUNT: `${prefix}unmount`,
  RESET: `${prefix}reset`,
}

const types = Object.assign({}, actions.types, newTypes)

actions.setBooleanFilter = (field, value) => {
  return {
    type: types.SET_BOOLEAN_FILTER,
    field,
    value,
  }
}

actions.reset = () => {
  return {
    type: types.RESET,
  }
}

actions.unmount = () => {
  return {
    type: types.UNMOUNT,
  }
}

const makeMessages = (messages, type) => {
  let sticky = false
  let summary = 'Sucesso!'
  if (type === 'error') {
    summary = 'Erro!'
    sticky = true
  } else if (type === 'warn') {
    summary = 'Aviso!'
    sticky = true
  }
  return messages.map((message) => {
    return {
      sticky: sticky,
      summary: summary,
      severity: type,
      detail: message,
    }
  })
}

export { types, actions }
